// @ts-nocheck
import React from 'react';
import { X, Calendar, User, Tag } from 'lucide-react';
import StatusBadge from './StatusBadge';
import PriorityIndicator from './PriorityIndicator';

const TicketHeader = ({ ticket, onClose, userRole }) => {
  const formatRelativeTime = (date) => {
    const now = new Date();
    const ticketDate = new Date(date);
    const diffInHours = Math.floor((now - ticketDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Less than an hour ago';
    if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    
    return new Date(date).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // normalize fields coming from different backends
  const statusVal = (ticket.status || ticket.state || '').toString().toLowerCase();
  const createdAt = ticket.createdAt ?? ticket.date ?? ticket.created_at;
  const title = ticket.title ?? ticket.subject ?? ticket.name ?? '';
  const customerName = ticket.customerName ?? ticket.customer ?? ticket.requester ?? null;

  return (
    <div className="flex items-start justify-between p-6 border-b border-line dark:border-white/[0.06]">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-sm font-mono text-content-muted">#{ticket.id}</span>
          <StatusBadge status={statusVal} />
          {ticket.priority && <PriorityIndicator priority={ticket.priority} />}
        </div>
        <h2 className="text-xl font-semibold text-content dark:text-gray-100 mb-2">{title}</h2>
        <div className="flex items-center gap-4 text-sm text-content-secondary dark:text-gray-300">
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            <span>Created {formatRelativeTime(createdAt)}</span>
          </div>
          {userRole !== 'customer' && customerName && (
            <div className="flex items-center gap-1">
              <User className="w-4 h-4" />
              <span>{customerName}</span>
            </div>
          )}
          <div className="flex items-center gap-1">
            <Tag className="w-4 h-4" />
            <span>{ticket.category ?? ticket.type ?? 'General'}</span>
          </div>
          {ticket.assignedAgentName && userRole !== 'customer' && (
            <div className="flex items-center gap-1">
              <User className="w-4 h-4" />
              <span>Assigned to {ticket.assignedAgentName}</span>
            </div>
          )}
        </div>
        
        {/* Response Time Metrics */}
        {userRole !== 'customer' && (
          <div className="flex items-center gap-4 text-xs text-content-muted mt-2">
            {ticket.firstResponseAt && (
              <span>
                First response: {formatRelativeTime(ticket.firstResponseAt)}
              </span>
            )}
            {ticket.resolvedAt && (
              <span>
                Resolved: {formatRelativeTime(ticket.resolvedAt)}
              </span>
            )}
            {ticket.escalationLevel > 0 && (
              <span className="text-orange-600 dark:text-orange-300 font-medium">
                Escalation Level: {ticket.escalationLevel}
              </span>
            )}
          </div>
        )}
      </div>
      <button aria-label="Close"
        onClick={onClose}
        className="text-content-subtle hover:text-content-secondary transition-colors ml-4"
      >
        <X className="w-6 h-6" />
      </button>
    </div>
  );
};

export default TicketHeader;